// Phase 17-C item 9: first-touch acquisition attribution.
// Captured ONCE per device into localStorage (utm_* + referrer + landing
// path) and relayed on the signup/auth calls; the backend sanitises it and
// persists it only when an account is CREATED — existing users are never
// overwritten, so this stays honest first-touch data.
const KEY = "civic_attrib";

export function captureFirstTouch() {
  try {
    if (localStorage.getItem(KEY)) return; // first touch only
    const params = new URLSearchParams(window.location.search);
    localStorage.setItem(KEY, JSON.stringify({
      source: params.get("utm_source") || "",
      medium: params.get("utm_medium") || "",
      campaign: params.get("utm_campaign") || "",
      referrer: document.referrer || "",
      landing_path: window.location.pathname + window.location.search,
    }));
  } catch { /* storage unavailable — attribution is best-effort */ }
}

export function getAttrib() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch { return undefined; }
}
